import React from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { useLanguage } from "../contexts/LanguageContext";
import { translate } from "../translations";

function InternshipOffer() {
  const { language } = useLanguage();

  return (
    <>
      <Header />
      <div className="stage-page">
        <div className="header-fill"></div>
        <article className="stage-article container">
          <header className="stage-header">
            <div className="stage-title-row">
              <span className="stage-icon" aria-hidden="true">💼</span>
              <h1 className="stage-title">
                {translate("stageTitle", language)}
              </h1>
            </div>
            <p className="stage-subtitle">
              {translate("stageSubtitle", language)}
            </p>
            <p className="stage-tags">
              SaaS — IA — {translate("stageTagMobile", language)}
            </p>
          </header>

          <div className="stage-contact stage-contact-bar">
            <p>
              Yoann Couillec — CTO & {translate("stageFounder", language)} YGALAAD
            </p>
            <a href="mailto:career@ygalaad.com">career@ygalaad.com</a>
          </div>

          <div className="stage-intro">
            <p>{translate("stageIntro1", language)}</p>
            <p>{translate("stageIntro2", language)}</p>
          </div>

          <section className="stage-section">
            <h2>{translate("stageContext", language)}</h2>
            <ul>
              <li>{translate("stageContext1", language)}</li>
              <li>{translate("stageContext2", language)}</li>
              <li>{translate("stageContext3", language)}</li>
            </ul>
          </section>

          <section className="stage-section">
            <h2>{translate("stageMissions", language)}</h2>
            <ul>
              <li>{translate("stageMission1", language)}</li>
              <li>{translate("stageMission2", language)}</li>
              <li>{translate("stageMission3", language)}</li>
            </ul>
          </section>

          <section className="stage-section">
            <h2>{translate("stageProfile", language)}</h2>
            <ul>
              <li>{translate("stageProfile1", language)}</li>
              <li>{translate("stageProfile2", language)}</li>
              <li>{translate("stageProfile3", language)}</li>
              <li>{translate("stageProfile4", language)}</li>
              <li>{translate("stageProfile5", language)}</li>
            </ul>
          </section>

          <section className="stage-section">
            <h2>{translate("stageBenefits", language)}</h2>
            <ul>
              <li>{translate("stageBenefit1", language)}</li>
              <li>{translate("stageBenefit2", language)}</li>
              <li>{translate("stageBenefit3", language)}</li>
              <li>{translate("stageBenefit4", language)}</li>
              <li>{translate("stageBenefit5", language)}</li>
            </ul>
          </section>

          <section className="stage-section stage-practical">
            <h2>{translate("stagePractical", language)}</h2>
            <ul>
              <li>{translate("stagePractical1", language)}</li>
              <li>{translate("stagePractical2", language)}</li>
              <li>
                {translate("stagePractical5", language)}{" "}
                <a href="mailto:career@ygalaad.com">career@ygalaad.com</a>
              </li>
            </ul>
          </section>

          <div className="stage-cta">
            <a href="mailto:career@ygalaad.com" className="stage-cta-btn">
              {translate("stageApply", language)}
            </a>
            <a
              href="/pdf/internship_marketing.pdf"
              className="stage-other-link"
              download
              target="_blank"
              rel="noopener noreferrer"
            >
              {translate("stageDownloadPdf", language)}
            </a>
            <Link
              to={`/${language}/stage-ingenieur`}
              className="stage-other-link"
            >
              {translate("stageOtherOfferEngineer", language)}
            </Link>
          </div>
        </article>
      </div>
      <Footer />
    </>
  );
}

export default InternshipOffer;
